module.exports = "/static/assets/085c5eb3b205117750cc64925b74a284.png";